import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import {Grid} from '@material-ui/core'
import User from "EurestoClass/User";
import Constants from "EurestoFonction/Constants";
import DataView from "EurestoComponents/DataForm";
import Data from 'EurestoClass/Data'
import Utils from 'EurestoFonction/Utils'
import Listing from "Components/Listing";
import DatePicker from "Components/DatePicker";
import moment from "moment";

const styleGrid = {
    margin: 0, padding: 0
}

export default React.memo(props => {
    const guid = useMemo(() => Utils.uuidv4(), [])
    const [classes, setClasses] = useState(Data.list(Constants.module.PEDAGOGIE, Constants.donnee.classe), [])

    const [annee, setAnnee] = useState(moment().isBefore(moment().format('YYYY-07-05')) ? moment().subtract(1, 'years').format('YYYY') : moment().format('YYYY'))

    const [classeId, setClasseId] = useState(null)

    const classe = useRef({}, [])
    const [rowClasses, setRowClasses] = useState([], [])

    const [selectedRowIndex, setSelectedRowIndex] = useState(undefined)

    const restate = useCallback(data => {
        const ds = Data.list(Constants.module.PEDAGOGIE, Constants.donnee.classe)
        setClasses(ds || [])
    }, [setClasses])

    useEffect(() => {
        Data.addCbRestate(Constants.module.PEDAGOGIE, Constants.donnee.classe, restate);
        return () => Data.resetCbRestate(Constants.module.PEDAGOGIE, Constants.donnee.classe);
    }, [restate])

    useEffect(() => {
        const ds = Data.list(Constants.module.PEDAGOGIE, Constants.donnee.classe, {annee: parseInt(annee)})
        setClasses(ds || [])
    }, [annee])


    const onChangeAnnee = useCallback(data => {
        setAnnee(moment(data[0]).format('YYYY'))
    }, [setAnnee])

    useEffect(() => {
        console.log(Utils.sortParentChildren(classes, 'classes_id'))
        setRowClasses([
            {
                label: annee,
                value: -1,
                html:
                    <DatePicker
                        year
                        scolaire
                        title={EurestoI18n.t('commun:Année Scolaire')}
                        onChange={onChangeAnnee}
                        name={'annee'}
                        value={[moment(annee+'-01-01').format('YYYY-MM-DD'), moment(annee+'-12-31').format('YYYY-MM-DD')]}
                    />},
            {
                label: '--- Toutes ---',
                value: null,
                html: <Grid container spacing={0} style={{margin:0,padding:0}} justify={"center"} alignItems={"center"} alignContent={"center"}><strong>{'Tous'}</strong></Grid>
            },
            ...Utils.sortParentChildren((classes||[]), 'classes_id').map(c => !c.classe_id && ({
                label: c.libelle,
                value: c.id,
                html: <strong>{c.libelle}</strong>
            }) || ({
                label: c.libelle,
                html: <span style={{ paddingLeft: 5 }}>{c.libelle}</span>,
                value: c.id,
            }))
        ])
    }, [classes])

    useEffect(() => {
        if(selectedRowIndex >= 0) {
            setSelectedRowIndex(rowClasses.findIndex(c => c.value === classeId))
        }
    }, [rowClasses])

    const onClickClasse = useCallback((cid) => {
        setClasseId(cid)
        setSelectedRowIndex(rowClasses.findIndex(c => console.log(c.value, cid) || c.value === cid))
    }, [setClasseId, setSelectedRowIndex, rowClasses])



    const filterEleve = useCallback((eleve) => eleve.classes.findIndex(c => c.classe_id === classeId
        || classeId === (Data.get(Constants.module.PEDAGOGIE, Constants.donnee.classe, {id: c.classe_id})||{}).classe_id) !== -1
        , [classeId])

    return <Grid container spacing={0} style={styleGrid}>
        <Grid item xs={2}>
            <EurestoDiv title={'Classe'}
                        style={{
                            margin: 0,
                            padding: 0,
                            maxHeight: User.CalculHeight.getHeightWanted(40),
                            height: User.CalculHeight.getHeightWanted(50),
                            overflowY: 'auto'
                        }}>
                <Listing hideHeader={true} selectedRowIndex={selectedRowIndex}  style={{
                    maxHeight: 'calc(100% - 30px)',
                }} data={rowClasses} onClick={onClickClasse}/>
            </EurestoDiv>
        </Grid>
        <Grid item xs={10} key={'pedagogie_eleve_formulaire_'+classeId} style={{padding: 0, margin: 0, height: User.CalculHeight.getHeightWanted(40) }}>
            <DataView filter={classeId && filterEleve} module={Constants.module.PEDAGOGIE} object={Constants.donnee.eleve}/>
        </Grid>
    </Grid>
})


// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Pedagogie/ClasseEleve/index.js